import { reactive } from 'vue'

export type NotifyType = 'success' | 'error' | 'warning' | 'info'

export interface NotifyItem {
  id: number
  type: NotifyType
  message: string
  duration: number | null
  timer: ReturnType<typeof setTimeout> | null
}

const state = reactive<{ items: NotifyItem[] }>({ items: [] })
let seed = 0

function add(type: NotifyType, message: string, duration?: number | null) {
  const id = ++seed
  const item: NotifyItem = {
    id,
    type,
    message,
    duration: duration === undefined ? 3000 : duration,
    timer: null,
  }
  state.items.push(item)
  if (item.duration !== null) {
    item.timer = setTimeout(() => remove(id), item.duration)
  }
  return id
}

function remove(id: number) {
  const idx = state.items.findIndex((i) => i.id === id)
  if (idx !== -1) {
    const item = state.items[idx]!
    if (item.timer) clearTimeout(item.timer)
    state.items.splice(idx, 1)
  }
}

export const notify = {
  state,
  remove,
  success(msg: string, duration?: number | null) {
    return add('success', msg, duration)
  },
  error(msg: string, duration?: number | null) {
    return add('error', msg, duration)
  },
  warning(msg: string, duration?: number | null) {
    return add('warning', msg, duration)
  },
  info(msg: string, duration?: number | null) {
    return add('info', msg, duration)
  },
}
